import { Framework } from '@/framework/instance';
import { IEditMessage } from '../../types';
import { OperateType } from '../../types/operate';
import { parseWsKey } from '../../utils';
import { Collaborators } from '../collaborators';
import { Room } from '../room';

/**
 * 用户就绪操作
 */
export class UserReady extends Framework {
    constructor(
        identity: string,
        private room: Room,
        private collaborators: Collaborators,
    ) {
        super(identity);
        this.room.onMessage(OperateType.UserReady, this.onReceiveUserReady.bind(this));
    }

    /** 发送用户就绪事件 */
    send() {
        const member = this.collaborators.getMember();
        if (member && !member.getInfo().isReady) {
            member.setReady(true);
            this.room.sendToAll(OperateType.UserReady, [1]);
            return true;
        }
        return false;
    }

    /** 收到用户就绪事件回调 */
    private onReceiveUserReady({ fromWsMemberKey }: IEditMessage<number[]>) {
        const { wsKey } = parseWsKey(fromWsMemberKey);
        this.collaborators.getMember(wsKey)?.setReady(true);
        this.room.renderUserPick();
    }
}
